"use client";

import { useReferrerStorage } from "@repo/design-system/hooks/use-job-pipeline";
import { useEffect } from "react";

export function SetReferrer() {
  const [referrer, setReferrer] = useReferrerStorage();

  useEffect(() => {
    if (!referrer) {
      const referrerUrl = new URL(document.referrer || location.href);

      setReferrer(
        referrerUrl.origin !== location.origin ? referrerUrl.origin : "Jobboard"
      );
    }
  }, [referrer, setReferrer]);

  return null;
}
